import styled from 'styled-components'
import { useLocale } from '../../hooks/useLocale'
import { theme } from '../../theme/theme'
import { Title4 } from '../styles/Typography'
import { Caret } from '../icons'
import { formatMonthYear } from '../../utils/dates'

interface CalendarHeaderProps {
  weekStart: Date
  onPreviousWeek: () => void
  onNextWeek: () => void
}

export const CalendarHeader = ({ weekStart, onPreviousWeek, onNextWeek }: CalendarHeaderProps) => {
  const locale = useLocale()

  return (
    <Container>
      <MonthHeader>
        <MonthYearText>{formatMonthYear(weekStart, locale)}</MonthYearText>
        <NavButtonsContainer>
          <NavButton onClick={onPreviousWeek} aria-label="Previous week" type="button">
            <Caret left size={24} color={theme.color.plumMid} />
          </NavButton>
          <NavButton onClick={onNextWeek} aria-label="Next week" type="button">
            <Caret size={24} color={theme.color.plumMid} />
          </NavButton>
        </NavButtonsContainer>
      </MonthHeader>
    </Container>
  )
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.medium}px;
  margin-bottom: ${theme.spacing.mediumLarge}px;
`

const MonthHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 ${theme.spacing.small}px;
`

const MonthYearText = styled(Title4)`
  text-transform: capitalize;

  @media screen and (max-width: ${theme.breakpoint.medium}px) {
    text-align: center;
  }
`
const NavButtonsContainer = styled.div`
  display: flex;
  gap: ${theme.spacing.small}px;
`

const NavButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: ${theme.spacing.tiny}px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: ${theme.spacing.xsmall}px;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: ${theme.color.beigeLight};
  }

  &:active {
    background-color: ${theme.color.beige};
  }
`
